import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFuelType'
})
export class SearchFuelTypePipe implements PipeTransform {

  transform(fuel_types: any, searchText: string){
    if (!searchText) {
      return fuel_types; // Return the original array if search text is empty
    }

    searchText = searchText.toLowerCase(); // Convert the search text to lowercase for case-insensitive comparison

    return fuel_types.filter((fuel_types: any) => fuel_types.type.toLowerCase().includes(searchText));
  }

}
